import {BaseStore} from '@spartacus/core/src/model/misc.model';
import {Country} from '@spartacus/core/src/model/address.model';
import {TypeValuePair} from '@dcp/configurator';
import {DeliveryMode} from '@spartacus/cart/base/root';

export interface DcpBaseStoreModel extends BaseStore {
  data: TypeValuePair[];
  createReturnProcessCode: string;
  deliveryCountries: Country[];
  deliveryModes: {
    deliveryModes: DcpDeliveryMode[];
  };
  externalTaxEnabled: boolean;
  maxRadiusForPosSearch: number;
  name: string;
  paymentProvider: string;
  pointsOfService: any[];
  submitOrderProcessCode: string;
}

export interface DcpDeliveryMode extends DeliveryMode {
  supportedPaymentModes: {
    paymentModes: DeliveryMode[];
  };
}

export interface RestrictedPaymentTypesResponse {
  restrictedPaymentTypes: {
    individual: string[];
    organization: string[];
  };
}

export enum PaymentMethods {
  INVOICE = 'invoice',
  CREDITCARD = 'creditcard',
}
